import { defineMessages } from "react-intl";
const messages = defineMessages({
    actionsPrivacy: {
        id: "app.space.details.toolbar.actions.privacy.text",
        defaultMessage: "Public",
    },
    actionsEmbedCode: {
        id: "app.space.details.toolbar.actions.embedCode.text",
        defaultMessage: "Embed Code",
    },
    actionsDownload360Photo: {
        id: "app.space.details.toolbar.actions.download360Photo.text",
        defaultMessage: "Download 360° Photos",
    },
    errorDownload360Photo: {
        id: "app.space.details.toolbar.actions.download360Photo.error",
        defaultMessage: "Error downloading 360° photos. Please try again.",
    },
});
export default messages;
